import { useEffect, useState } from 'react';

import { useAppSelector } from 'store/store-hooks';
import { getInternalPlayer } from 'components/app/_helpers/_app.helper';
import { SB_EVENT } from 'components/app/storyboard/_mediator/sb-const';
import { useSbPlayerContext } from '../_mediator/sb-player.provider';

export const usePlayerActive = () => {
  const { playbackClips, activePlayerIndex } = useAppSelector((state) => state.sb__player);
  const { sbPlayers } = useSbPlayerContext();
  const [player, setPlayer] = useState<HTMLVideoElement | null>(null);

  useEffect(() => {
    const onInit = (e: Event) => {
      const { index } = (e as CustomEvent).detail;
      if (index !== activePlayerIndex) return;
      document.removeEventListener(SB_EVENT, onInit);
      setPlayer(getInternalPlayer(sbPlayers.current[activePlayerIndex])!);
    };
    const onCanplay = () => {
      player!.removeEventListener('canplay', onCanplay);
      setPlayer(player!);
    };
    setPlayer(null);
    const player = getInternalPlayer(sbPlayers.current[activePlayerIndex]);
    if (player) player.addEventListener('canplay', onCanplay);
    else document.addEventListener(SB_EVENT, onInit);
    return () => {
      if (player) player.removeEventListener('canplay', onCanplay);
      else document.removeEventListener(SB_EVENT, onInit);
    };
  }, [playbackClips[activePlayerIndex]]);

  return player;
};
